import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../../services/Api/Admin/adminApi";
import { api } from "../../../../../../../services/Api/api";
import { OrganizationProductApi, SearchSelectApi } from "../../../../../../../services/Api/types";
import OrganizationProductsTableForm from "../../../../../components/Organization/OrganizationProductsTableForm";

interface MatchParams {
	organizationId: string;
}

const AdminOrganizationProductsPage = () => {
	const { organizationId } = useParams<MatchParams>();
	const { t } = useTranslation("admin");
	const history = useHistory();
	const [products, setProducts] = useState<OrganizationProductApi[] | undefined>();
	const [possibleProducts, setPossibleProducts] = useState<SearchSelectApi[] | undefined>();
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(
			`${t("modules.organization.field.products.title")} | ${t("modules.organization.header.title")} | ${t(
				"lib:go_component.navigation.admin"
			)}`
		);
		fetch();
	}, []);

	const fetch = async () => {
		await Promise.all([fetchProducts(), fetchPossibleProducts()]);
	};

	const fetchProducts = async () => {
		try {
			const res = await adminApi.getOrganizationProducts(Number(organizationId));
			setProducts(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const fetchPossibleProducts = async () => {
		try {
			const res = await api.getOrganizationProductSearchSelect("", { size: 0 });
			setPossibleProducts(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	const goBack = () => {
		history.push(`/admin/organizations/${organizationId}`);
	};

	if (!products || !possibleProducts) return <LoadingContainer />;

	return (
		<div className="content">
			<Header back={goBack} title={t("modules.organization.field.products.title")} />
			<OrganizationProductsTableForm
				products={products}
				organizationId={Number(organizationId)}
				possibleProducts={possibleProducts}
			/>
		</div>
	);
};

export default AdminOrganizationProductsPage;
